// extracted by mini-css-extract-plugin
export default {"home":"home__uRcqa"};